<script setup>
import {computed} from "vue";
import {getNoun} from "../../../helpers/string";

const props = defineProps(['need']);

const solutionsEvaluated = computed(() => {
    return props.need.solutions_liked_count >= 5;
})

const solutionsReviewed = computed(() => {
    return solutionsEvaluated.value && props.need.solutions_reviewed_count >= props.need.solutions_liked_count;
})

const progressPerc = computed(() => {
    if (props.need.is_escalated) {
        return 100;
    }

    let perc = 8 + (Math.min(props.need.solutions_liked_count, 5) / 5) * 27;

    if (props.need.solutions_liked_count >= 5) {
        perc += (props.need.solutions_reviewed_count / props.need.solutions_liked_count) * 29;
    }

    return perc;
})
</script>

<template>
    <div class="card card--need">
        <h5 class="heading5"><a :href="`/needs/${need.id}`" target="_blank">{{ need.name }}</a></h5>

        <div class="card--need__content">
            <div class="card--need__text">
                <p>{{ need.description }}</p>
            </div>

            <template v-if="!need.is_escalated">
                <a v-if="need.solutions_new_ai_count" :href="`/needs/${need.id}?openMatchMaking=ai`" target="_blank" class="link-arrow">View New Matches</a>
                <a v-else-if="need.solutions_new_eco_count" :href="`/needs/${need.id}?openMatchMaking=ecosystem`" target="_blank" class="link-arrow">View New Matches</a>
            </template>
        </div>

        <ul class="list-info">
            <li class="list-info__startup">{{need.solutions_liked_count}} Evaluated {{getNoun('Solution', need.solutions_liked_count)}} </li>
            <li v-if="!need.is_escalated" class="list-info__recommended">{{need.solutions_new_ai_count + need.solutions_new_eco_count}} Recommended {{getNoun('Solution', need.solutions_new_count)}} </li>
        </ul>

        <div class="needs-stats">
            <div class="needs-stats__progress" :style="`width: ${progressPerc}%`"></div>
            <ul class="needs-stats__steps">
                <li class="needs-stats__steps__created needs-stats__steps__active">Need Created</li>
                <li class="needs-stats__steps__matched" :class="{'needs-stats__steps__active': solutionsEvaluated || need.is_escalated}">Solutions Evaluated</li>
                <li class="needs-stats__steps__reviewed" :class="{'needs-stats__steps__active': solutionsReviewed || need.is_escalated}">Solutions Reviewed</li>
                <li class="needs-stats__steps__escalated" :class="{'needs-stats__steps__active': need.is_escalated}">Need Escalated</li>
            </ul>
        </div>
    </div>
</template>

<style scoped>

</style>
